export class AnalyticsContext<Attributes extends object> {
  constructor(private attributes: Attributes) {}

  public get(): Attributes {
    return this.attributes;
  }

  public set(attributes: Attributes): void {
    this.attributes = attributes;
  }
}

export const mergeAnalyticsAttributes = (
  ...attributeSets: Array<object | null | undefined>
): Record<string, unknown> =>
  attributeSets.reduce<Record<string, unknown>>((mergedAttributes, attributeSet) => {
    if (!attributeSet) {
      return mergedAttributes;
    }

    for (const [key, value] of Object.entries(attributeSet)) {
      if (value !== undefined) {
        mergedAttributes[key] = value;
      }
    }

    return mergedAttributes;
  }, {});
